import { render, staticRenderFns } from "./historial-exclusiones-de-hogar.vue?vue&type=template&id=8883fe78&"
import script from "./historial-exclusiones-de-hogar.vue?vue&type=script&lang=ts&"
export * from "./historial-exclusiones-de-hogar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports